import type { IconSvgObject } from './types';

const ChevronsRightIcon: IconSvgObject = [
  ["path", { d: "M6.00004 17C6.00004 17 11 13.3176 11 12C11 10.6824 6 7 6 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 17C13 17 18 13.3176 18 12C18 10.6824 13 7 13 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsRightIcon;
